<!--
 * @Description: 分配医生空状态
 * @Author: leeyna
 * @Date: 2021-12-16 19:43:05
 * @LastEditTime: 2021-12-16 19:59:02
 * @LastEditors: leeyna
-->
<template>
  <div class="container">
    <img class="empty" src="@/assets/img01.png">
    <div class="tip">暂无医生服务</div>
  </div>
</template>
<script>

export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #f5f5f5;
  height: calc(100vh - 44px);

  @include flex(center, center);

  flex-direction: column;

  .empty {
    width: 160px;
    height: 141px;
  }

  .tip {
    margin-top: 10px;

    @include font(14px, 18px, #9A9FA8);
  }
}
</style>
